const getAllTradeMedicData = state => state.tradeMedicData;

export default getAllTradeMedicData;